import React, { useEffect, useState } from "react";
import { Box, Breadcrumbs, Chip, Divider, emphasize, Grid2, IconButton, styled, Tab, Tabs, Tooltip, Typography, useTheme } from "@mui/material";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import projectMenus from "./menu-items";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useCheckMenuPermission } from "hooks/useCheckMenuPermission";
import {ReactComponent as LeftArrowicon} from "assets/PwC_Funct_Icons_ArrowLeft_Outline_Black_RGB.svg"

const StyledTab = styled(Tab)(({ theme }) => ({
    textTransform: "none", // Prevent uppercase
    fontWeight: "400",
    fontSize: "16px",
    color: "#696969",
    padding: '0px',
    minHeight: '0px',
    minWidth: '0px',
    margin: '0px 13px 5px 13px',
    // Apply different margin for the first tab
    "&:first-of-type": {
        marginLeft: "0px", // Set margin-left to 0 for the first tab
    },
    "&.Mui-selected": {
        color: `${theme?.customSettings?.themeColor}`, // Selected tab color
    }
}));


const tabs = [
    { label: "All", path: "all-issue", index: 0 },
    { label: "Pending", path: "pending-approval", index: 1 },
    { label: "Submitted by me", path: "submitted-by-me", index: 2 },
];


const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    return {
        backgroundColor: theme.palette.grey[100],
        height: theme.spacing(3),
        color: (theme.vars || theme).palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: emphasize(theme.palette.grey[100], 0.06),
            ...theme.applyStyles('dark', {
                backgroundColor: emphasize(theme.palette.grey[800], 0.06),
            }),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(theme.palette.grey[100], 0.12),
            ...theme.applyStyles('dark', {
                backgroundColor: emphasize(theme.palette.grey[800], 0.12),
            }),
        },
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    };
}) // TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591

const PageMenu = (props) => {
    const { mainRoute } = props;
    const [menus, setMenus] = useState([]);
    const [submenu, setSubmenu] = useState(false);
    const theme = useTheme();
    const navigate = useNavigate();
    const { hasPermission } = useCheckMenuPermission();
    const location = useLocation();
    const { activityId, projectId } = useParams();

    const currentTab = menus?.submenus?.find(tab => tab.route === location?.pathname?.split("/")?.[4]);

    const tabIndex = currentTab ? currentTab.route : 0;

    const handleChange = (_, newIndex) => {
        const newTab = menus?.submenus?.find(tab => tab.route === newIndex);

        if (activityId) {
            if (newTab) navigate(`${menus?.route}/${newTab?.route}/${activityId}`);
            return;
        }
        if (newTab) navigate(`${menus?.route}/${newTab?.route}`);

    }

    useEffect(() => {
        const mainRoute = location?.pathname?.split("/")?.[3];
        const pageMenus = projectMenus?.headerMenus?.find(val => val?.route === mainRoute);

        // const exists = pageMenus?.submenus?.some(submenu => submenu?.route === location?.pathname?.split("/")?.[4]);

        // setSubmenu(exists);
        setMenus(pageMenus);

    }, [location])
    return (
        <>
            {menus?.isTopBar &&
                <Grid2 container spacing={2} sx={{ mt: '20px' }}>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                        {/* <ExpandMore sx={{ mr: 1, color: '#252525' }} /> */}
                        <Typography variant="h5" sx={{ fontSize: '24px', fontWeight: '500', color: '#252525', mb: 2, lineHeight: "32px", letterSpacing: '-0.4px' }}>
                            {menus?.route == 'documents' &&
                                <Tooltip
                                    placement="bottom"
                                    title="Activity List"
                                    arrow
                                    slotProps={{
                                        tooltip: { sx: { fontSize: "12px" } },
                                    }}
                                >
                                    <IconButton
                                        aria-label="download"
                                        size="small"
                                        onClick={() => {
                                            navigate(`/projects/${projectId}/engineering/all-activities`)
                                        }}
                                    >
                                        {/* <IoMdArrowRoundBack style={{ height: '22px', width: '22px', color: "#252525" }} /> */}
                                        <LeftArrowicon style={{ height: '22px', width: '22px', fill: "#252525", stroke:"#252525", strokeWidth:4 }} />
                                    </IconButton></Tooltip>
                            }
                            {menus?.menu}
                        </Typography>
                    </Box>

                    {menus?.submenus?.length > 0 &&
                        <Grid2 size={12}>
                            <Box sx={{ width: "100%" }}>
                                <Tabs
                                    value={tabIndex}
                                    onChange={handleChange}
                                    aria-label="URL-based tabs"
                                    sx={{
                                        minHeight: "0px",
                                        "& .MuiTabs-indicator": { backgroundColor: `${theme?.customSettings?.themeColor}` },
                                    }}
                                >
                                    {menus?.submenus?.filter((sub, ind) => hasPermission([menus?.permissionKey?.[ind]]) > 0 || !menus?.permissionKey)?.map((tab, key) => (
                                        <StyledTab key={tab?.route} value={tab?.route} label={tab.name} disabled={tab.disabled} />
                                    ))}
                                </Tabs>
                                <Divider sx={{ borderColor: '#fff', borderBottomWidth: "initial" }} />
                            </Box>
                        </Grid2>
                    }

                </Grid2>
            }
        </>
    );
};

export default PageMenu;